<template>
  <div class="main-container" id="OrganisationsView">
    <div class="content">
      <div class="content-body">
        <div class="body-container">
          <div class="header-container" v-if="isAdmin">
            <div class="header-top">
              <div class="site-heading">Organizations</div>
              <alert
                styleclass="alert-yellow"
                icon="warning"
                message="You are logged in as a global administrator!"
                class="max-w-50"
              >
                <template v-slot:icon>
                  <img
                    class="logo"
                    src="@/assets/img/organization/picflow-logo-letter.svg"
                    alt="PicFlow logo"
                  />
                </template>

                <template v-slot:text>
                  <span class="alert-text"
                    >You are logged as <span class="highlight"> SUPER ADMIN </span>
                  </span>
                </template>
              </alert>
            </div>
            <div class="header-bottom">
              <!-- <i
                class="material-icons-outlined align-middle button"
                :class="{ active: showOrganisationsFilters }"
                title="Filter Organisations"
                @click="organisationFilterIconClick"
              >
                filter_alt
              </i> -->

              <div class="button-row">
                <div class="filter-container">
                  <i class="material-icons-outlined align-middle">
                    <!-- title="New Organisation"
                  @click="openCreateOrganisationModal" -->
                    filter_alt
                  </i>
                </div>
                <SearchButton class="search-container" v-model="organisationSearchText" />

                <!-- Byta ut till filter ikon -->
                <div class="add-organization" @click="openCreateOrganisationModal">
                  <i class="material-icons-outlined align-middle button" title="New Organisation">
                    add
                  </i>
                  Add Organization
                </div>
              </div>
            </div>
            <div v-if="showOrganisationsFilters" class="filters">
              <!-- TODO: Example (No filters yet) -->
              <!-- <label for="groupsStatus" class="status">
                <span>Playlists</span>
                <select
                  ref="groupsStatus"
                  name="groupsStatus"
                  id="groupsStatus"
                  @change="manageFilters('groupsStatus')"
                  v-model="filters.groupsStatus"
                >
                  <option value="all">All</option>
                  <option value="online">Online</option>
                  <option value="offline">Offline</option>
                  <option value="unknown">Unknown</option>
                </select>
              </label> -->
            </div>
          </div>

          <div class="header-organization-admin" v-if="isOrganizationAdmin && !isAdmin">
            <div class="header-top">
              <i class="material-icons align-middle button">business_center</i>
              <div class="title">{{ organisation?.name || user?.username }}</div>
            </div>
            <div class="header-bottom">
              <div class="data">
                <span class="data-label">Users:</span>
                <span class="data-value">{{ organisation?.statistics?.num_of_users || 0 }}</span>
              </div>
              <div class="data">
                <span class="data-label">Active Licenses:</span>
                <span class="data-value"
                  >{{ organisation?.statistics?.num_of_active_licenses || 0 }}/{{
                    organisation?.statistics?.num_of_licenses || 0
                  }}</span
                >
              </div>
            </div>
          </div>

          <div class="body" v-if="isAdmin">
            <OrganisationsList v-if="isAdmin" :search-term="organisationSearchText" />
          </div>
        </div>
      </div>
    </div>

    <CreateOrganisationModal
      v-if="showCreateOrganisationModal"
      @closeModal="showCreateOrganisationModal = false"
    />
    <!-- 
    <OrganisationSidebar v-if="!!organisation" @organisationUpdated="getOrganizations" />
    <OrganisationSidebarPlaceholder
      v-if="!organisation && isAdmin"
      @onCreate="openCreateOrganisationModal"
    /> -->
  </div>
</template>

<script>
  import {
    SET_CURRENT_ORGANISATION,
    ADMIN_ORGANISATIONS_GET,
    ORGANISATION_REQUEST,
    SET_ORGANISATIONS,
  } from '@/store/actions/organisation';
  import Alert from '@/components/Alert.vue';
  import OrganisationsList from '@/components/admin/OrganisationsList.vue';
  import CreateOrganisationModal from '@/components/admin/CreateOrganisationModal.vue';
  import OrganisationSidebar from '@/components/admin/OrganisationSidebar.vue';
  import OrganisationSidebarPlaceholder from '@/components/admin/OrganisationSidebarPlaceholder.vue';
  import SearchButton from '@/components/common/SearchButton.vue';

  export default {
    name: 'Organisation',

    components: {
      OrganisationSidebarPlaceholder,
      Alert,
      OrganisationsList,
      CreateOrganisationModal,
      OrganisationSidebar,
      SearchButton,
    },

    data() {
      return {
        showCreateOrganisationModal: false,
        showOrganisationsFilters: false,
        showOrganisationSearchBox: false,
        organisationSearchText: '',
      };
    },

    computed: {
      isOrganizationAdmin() {
        return this.$store.getters.isOrganizationAdmin;
      },

      isAdmin() {
        return this.$store.getters.isAdministrator;
      },

      organisation() {
        return this.$store.state.organisation.organisation;
      },

      organisationIdParam() {
        return this.$route.params.organisation_id;
      },

      user() {
        return this.$store.getters.getCurrentUser;
      },
    },

    async mounted() {
      const organisationsLoaded = this.$store.state.organisation.organisations.length !== 0;

      if (
        organisationsLoaded &&
        this.organisationIdParam &&
        this.organisation &&
        this.organisation?.organisation_id === this.organisationIdParam
      ) {
        return;
      }

      this.getOrganizations();
    },

    watch: {
      organisationIdParam(value) {
        if (!value) {
          this.$store.commit(SET_CURRENT_ORGANISATION, null, false);
        }
      },
    },

    methods: {
      async getOrganizations(refreshData = false) {
        if (this.isAdmin) {
          await this.$store.dispatch(ADMIN_ORGANISATIONS_GET, this.organisationIdParam);
          return;
        }

        if (!this.organisation || refreshData) {
          await this.$store.dispatch(ORGANISATION_REQUEST);
          this.$store.commit(SET_ORGANISATIONS, [this.organisation]);
        }
        if (this.isOrganizationAdmin) {
          this.$router.push({
            name: 'OrganisationDetails',
            params: { organisation_id: this.organisation.organisation_id },
          });
        }
      },

      openCreateOrganisationModal() {
        this.showCreateOrganisationModal = true;
      },

      organisationFilterIconClick() {
        this.showOrganisationsFilters = !this.showOrganisationsFilters;
      },

      organisationSearchIconClick() {
        this.showOrganisationSearchBox = !this.showOrganisationSearchBox;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .main-container {
    display: block;
  }

  .body-container {
    width: 100%;
    padding: 0 16px 40px;
    display: flex;
    flex-direction: column;

    .body {
      display: flex;
      flex-direction: column;
      overflow: hidden;

      padding-right: 2rem;
      margin-right: -2rem;
    }

    .site-heading {
      font-family: Poppins;
      font-weight: 400;
      font-size: 20px;
      line-height: 32px;
      letter-spacing: 0%;
      margin-bottom: 42px;
    }

    .button-row {
      width: 100%;
      display: grid;
      gap: 11px;
      grid-template-columns: 24px auto 180px;
    }

    .search-container,
    .filter-container {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .add-organization,
    .search-container,
    .filter-container:hover {
      cursor: pointer;
    }

    .add-organization {
      font-family: Poppins;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;
      text-align: center;
      color: #e3003a;
      display: flex;
      justify-content: end;
      align-items: center;
      gap: 12px;
    }

    .button {
      color: #e3003a;
    }
  }

  .filter-button-container {
    display: flex;
    align-items: center;
  }

  .alert {
    img {
      width: 24px;
      margin-right: 16px;
    }
  }

  .alert-text {
    font-family: Poppins;
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: 0%;
  }

  .header-organization-admin {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 16px 20px;
    border: 2px solid $primaryRed;
    background-color: #fff;

    .header-top {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;
      padding-bottom: 16px;
      border-bottom: 1px solid $lineGrey;
      color: $primaryText;
    }

    .header-bottom {
      display: flex;
      padding-top: 16px;
      gap: 24px;
      font-size: 14px;
      line-height: 21px;

      .data {
        display: flex;
        gap: 4px;

        .data-label {
          color: $secondaryText;
        }

        .data-value {
          color: $primaryText;
          font-weight: 500;
        }
      }
    }
  }
</style>
